<template>
  <div class="view-catalog"
       v-if="catalog">
    <header class="header">
      <marquee-text
        :duration="duration"
        :repeat="repeat">
        <h2 class="header-title mb-0"
            ref="headerTitle">
          <span class="text-danger text-uppercase ml-3"
                v-html="catalog.title.rendered"></span>
          <span v-if="catalog.content.rendered !== ''">{{ stripTags(catalog.content.rendered) }}</span>
        </h2>
      </marquee-text>
    </header>
    <section class="content">
      <portfolio-grid v-if="portfolio"
                      v-bind:portfolio="portfolio" />
    </section>
    <site-footer />
  </div>
</template>

<script>
export default {
  name: 'view-catalog',
  data () {
    return {
      catalog: false,
      duration: 30,
      repeat: 2
    }
  },
  beforeMount () {
    this.getCatalog()
  },
  mounted () {
    this.calcRepeat()
  },
  watch: {
    '$route.params.slug': function () {
      this.getCatalog()
    }
  },
  computed: {
    portfolio: function () {
      if (this.catalog.portfolio.show_projects) {
        return this.$store.getters.getProjects(this.catalog.portfolio.projects)
      }
      return this.catalog.portfolio.items
    }
  },
  methods: {
    calcRepeat: function () {
      let repeat = (window.innerWidth / this.$refs.headerTitle.clientWidth).toFixed()
      this.repeat = parseInt(repeat) <= 1 ? 2 : parseInt(repeat * 2)
      this.duration = this.$refs.headerTitle.clientWidth / 50
      // console.log(this.repeat, this.duration)
    },
    getCatalog () {
      this.catalog = this.$store.getters.getItemBySlug('catalog', this.$route.params.slug)
    },
    stripTags (html) {
      return html.replace(/(<([^>]+)>)/ig, '')
    }
  }
}
</script>
